import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        fallback: String,
    }

    static targets = ["commentInput"];

    connect() {
        this.element.addEventListener("error", (event) => {
            if (this.element.src != this.fallbackValue) this.element.src = this.fallbackValue
        })
        if (this.element.complete) {
            if (this.element.naturalWidth === 0 && this.element.src != this.fallbackValue) {
                this.element.src = this.fallbackValue
            }
        }

        this.handleStreamRender = this.handleStreamRender.bind(this)
        document.addEventListener('turbo:before-stream-render', this.handleStreamRender)
    }

    disconnect() {
        document.removeEventListener('turbo:before-stream-render', this.handleStreamRender)
    }

    scrollHistoryFrame(event) {
        const area = event.target.parentElement
        area.scrollTop = area.scrollHeight
    }

    handleStreamRender(event) {
        const streamTarget = event.target?.getAttribute?.('target') || ""
        if (!streamTarget.startsWith('sidebar-lead-comments-list-')) return

        // The sidebar comment list scrolls itself, so a new comment is scrolled into view there.
        const originalRender = event.detail.render
        event.detail.render = (streamElement) => {
            const result = originalRender(streamElement)
            const list = document.getElementById(streamTarget)
            if (list) list.scrollTop = list.scrollHeight
            return result
        }
    }

    // Enter submits; Shift+Enter inserts a newline (works on every OS)
    handleCommentKeydown(event) {
        if (event.key !== "Enter") return;
        if (event.shiftKey) return;
        event.preventDefault();
        event.target.closest("form").requestSubmit();
    }
}
